import { api } from '../lib/api.js';

/**
 * "CHECKED IN NOW" — everyone in the reader's scope on the clock right now,
 * at a site, a camp, an office or remote, less 16h+ opens (the API's
 * `onTheClock.ts`; a camp check-in counts since 2026-11-03). Not the per-site board (`liveSiteBoard.api.ts`), which
 * only sees legs opened at a worksite and stays what the Worksites rail and
 * the map read.
 */
export interface CheckedInNow {
  /** On the clock now, anywhere. */
  count: number;
}

/**
 * The ONE query key the figure is registered under: the rail's Overview badge
 * and the Overview tile observe this same cache entry, so they cannot state
 * two numbers about the same minute (owner, 2026-10-24: rail 283, tile 281).
 */
export const CHECKED_IN_NOW_QUERY_KEY = ['site-ops', 'checked-in-now'] as const;

export const checkedInNowApi = {
  get: (): Promise<CheckedInNow> =>
    api.get<{ data: CheckedInNow }>('/site-ops/checked-in-now').then((r) => r.data),
};
